import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import EventEditForm from './event-edit-form';

interface EventAddDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  timelineId: string;
  knowledgebaseId: string;
  caseId: string;
  ownerId: string;
}

export default function EventAddDialog({ open, onOpenChange, timelineId, knowledgebaseId, caseId, ownerId }: EventAddDialogProps) {
  const { t } = useTranslation();

  const handleSave = () => {
    onOpenChange(false);
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[80vh] flex flex-col p-0">
        <DialogHeader className="px-6 pt-6 pb-4 flex-shrink-0">
          <DialogTitle>{t('common.timeline.addEvent')}</DialogTitle>
          <DialogDescription>
            {t('common.timeline.addEventDescription')}
          </DialogDescription>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto px-6 min-h-0">
          {open && (
            <EventEditForm
              key={open ? 'create' : 'closed'}
              createMode={true}
              ownerId={ownerId}
              caseId={caseId}
              knowledgebaseId={knowledgebaseId}
              timelineId={timelineId}
              onCancel={handleCancel}
              onSave={handleSave}
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
